import { render, staticRenderFns } from "./OtpBoxes.vue?vue&type=template&id=cbe4414e&scoped=true&"
import script from "./OtpBoxes.vue?vue&type=script&lang=js&"
export * from "./OtpBoxes.vue?vue&type=script&lang=js&"
import style0 from "./OtpBoxes.vue?vue&type=style&index=0&id=cbe4414e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe4414e",
  null
  
)

export default component.exports